// AUTH0 CONFIGURATION
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  redirectUri: window.location.origin
};

// API CLIENT
import axios from 'axios';

export const api = axios.create({
  baseURL: '/.netlify/functions/neon-api'
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth0_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});